/**
 * Pure sparkline math — kept out of the component so it is unit-testable without a DOM.
 * Builds an SVG path string fitting `values` into a `w`×`h` box (y inverted so up = larger).
 */
export function sparklinePath(values: number[], w: number, h: number, pad = 1): string {
  if (values.length === 0) return "";
  const max = Math.max(...values, 0);
  const min = Math.min(...values, 0);
  const range = max - min || 1;
  const innerW = w - pad * 2;
  const innerH = h - pad * 2;
  const step = values.length > 1 ? innerW / (values.length - 1) : 0;
  return values
    .map((v, i) => {
      const x = pad + i * step;
      const y = pad + innerH - ((v - min) / range) * innerH;
      return `${i === 0 ? "M" : "L"}${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(" ");
}

/** Percent change of the last value vs the previous one — the "vs yesterday" delta. Null if N/A. */
export function lastDeltaPct(values: number[]): number | null {
  if (values.length < 2) return null;
  const prev = values[values.length - 2];
  const last = values[values.length - 1];
  if (prev === 0) return last === 0 ? 0 : null;
  return Math.round(((last - prev) / prev) * 100);
}
